import { SelectOption, ValidationItems } from '@kanda-libs/ks-component-ts';

export const QA_LINK = 'https://onboarding-qa.ideal4finance.co.uk/company/';
export const PROD_LINK = 'https://onboarding.ideal4finance.co.uk/company/';
export const MODAL_ID = 'training-status-modal';
export const OPTIONS: SelectOption[] = [
  { name: 'Training Required', value: 'training_required' },
  { name: 'Training Scheduled', value: 'training_scheduled' },
  { name: 'Training Done', value: 'training_done' },
];
export const VALIDATION: ValidationItems = {
  required: { value: true, message: 'Training status is required.' },
};
